<div>
    <div>
        <div>
            <div class="detail-bg-container text-center wrapper-position p-5">
                <div class="result-title">
                    <h3>{{translation['Failure']}}!</h3>
                    <p>{{failedMessage}}</p>
                </div>
                <div class="footer pb-4 pt-5">
                    <button mat-button (click)="tryAgain()">{{translation['TryAgain']}}</button>
                </div>
            </div>
        </div>
    </div>
</div>